import React from 'react';
import urls from '../configs/urls'
import '../css/App.css';
import ls from 'local-storage'
import axios from 'axios';
import Loading from "./Loading";
import mobileImg from "../images/mobile.png";
import Cookies from 'js-cookie'

class MobilePage extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            loading: false,
            phone : ls.get('phone'),
            rules : false,
            redirect : false,
        };
        this.setPhone = this.setPhone.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRules = this.handleRules.bind(this);
    }
    componentWillMount = () => {

    };

    render() {

        return (
            <div className="App">
                <div className="App-body bg-white">
                    <form onSubmit={this.handleSubmit}>
                        <h5 className={"title"}>ورود یا ثبت نام</h5>
                        <h6 className={"title2"}>شماره موبایل خود را وارد کنید</h6>
                        <div style={{width:"100%",overflow:"hidden",marginTop:"15vh"}}>
                            <img style={{float:"right",width:"35px",padding:"21px"}} src={mobileImg}/>
                            <input type="number"
                                   pattern="09[0-9]{9}"
                                   value={this.state.phone}
                                   title={"09**1234567"}
                                   onChange={this.setPhone}
                                   className={"inputNoBorder"}
                                   placeholder={"شماره موبایل"}
                                   style={{float:"right",width:"calc(100% - 150px)",
                                       position:"relative",height:"30px",marginTop:"20px"}}
                            />
                        </div>
                        <input type={"checkbox"}
                               value={this.state.rules}
                               onChange={this.handleRules}
                               style={{float:"right",marginRight:"25px"}}
                        />
                        <div style={{float:"right",marginRight:"10px",marginTop:"2px",fontSize:"14px",fontWeight:500,fontFamily:"irsans"}} >
                            <p style={{float:"right"}}>من با </p>
                            <a style={{float:"right"}}
                               href={"https:/asooone.ir/polity"} target={"_blank"}>&nbsp;&nbsp;قوانین&nbsp;&nbsp;</a>
                            <p style={{float:"right"}}> آسونه موافقم</p>
                        </div>

                        <input type={"submit"} className={"btn submitPhone"} value={"ارسال پیامک"}/>

                    </form>
                </div>
                <Loading loading={this.state.loading}/>
            </div>
        );
    }

    setPhone(event){
        this.setState({phone: event.target.value});
    }
    handleSubmit(event){
        event.preventDefault();
        let pattern = /^09[0-9]{9}$/;
        if(!pattern.test(this.state.phone)) {
            alert("لطفا شماره موبایل را به صورت 09123456789 وارد کنید.");
            return;
        }

        if(!this.state.rules){
            alert("لطفا قوانین را مطالعه کرده و تیک مربوط به موافقت با قوانین را بزنید.");
            return;
        }

        this.sendLogin();

    }
    handleRules(event){
        this.setState({rules: event.target.value});
    }
    sendLogin(){
        this.setState({loading:true});
        ls.set("phone",this.state.phone);
        let data = {
            phone:this.state.phone
        };
        axios.post(urls.baseUrl+urls.login,data)
            .then(res => {
                if(res.data.code == 200){
                    this.props.history.push('/verify');
                }
                else{
                    this.setState({loading:false});
                    alert("خطا : "+res.data.message);
                }
            })
            .catch(error=>{
                this.setState({loading:false});
                alert("خطا : "+error.toString());
            })
    }


}



export default MobilePage;
